export default {
  placeholder: 'Search',
  cancel: 'Cancel',
};
